"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { LogoutButton } from "@/features/auth";
import { Brand } from "./Brand";
import { navigationItems } from "./menuConfig";
import styles from "./MobileNavigation.module.css";

function isActiveRoute(pathname: string, href: string) {
  return href === "/" ? pathname === href : pathname === href || pathname.startsWith(`${href}/`);
}

export function MobileNavigation() {
  const pathname = usePathname();

  return (
    <>
      <header className={styles.mobileHeader}>
        <Brand />
        <LogoutButton className={styles.logoutButton} iconOnly />
      </header>

      <nav className={styles.bottomNav} aria-label="Primary navigation">
        <ul className={styles.bottomNavList}>
          {navigationItems.map((item) => {
            const Icon = item.icon;
            const isActive = isActiveRoute(pathname, item.href);

            return (
              <li key={item.href}>
                <Link
                  className={styles.bottomNavLink}
                  data-active={isActive ? "true" : undefined}
                  href={item.href}
                  aria-current={isActive ? "page" : undefined}
                >
                  <Icon />
                  <span>{item.label}</span>
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>
    </>
  );
}
